/** @ngInject */
export function Controller() {
    var url = window.location.href;
    var idx = url.indexOf("/loginSaml/client/sso/");
    if(idx > -1){
        var url = url.replace("#/", "");
        window.location.href = url;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/client-saml-login/client-saml-login.controller.js